import { fetchOrderList } from '../tools'
import type { HarnessPendingToolCall } from '../types'
import type { ClientToolExecution, OrderListToolData } from './types'

export async function executeOrderListTool(
  toolCall: HarnessPendingToolCall
): Promise<ClientToolExecution> {
  const result = await fetchOrderList(toolCall.name, toolCall.arguments)
  const query = toolCall.arguments.query as Record<string, unknown> | undefined
  const orderData: OrderListToolData = {
    total: result.total,
    page: Number(query?.page || 1),
    limit: Number(query?.limit || 20),
    orders: result.orders.map((order) => ({
      id: String(order.id),
      orderNo: order.order_code,
      address: order.buyer_address,
      customer: order.customer_name,
      createdAt: order.create_time,
      rooms: order.rooms.map((room) => ({
        id: String(room.id),
        name: room.name,
        createdAt: room.create_time,
      })),
    })),
  }
  return {
    toolCallId: toolCall.toolCallId,
    resultForAgent: {
      ok: true,
      data: { type: 'order-list', query, ...result },
    },
    orderData,
  }
}
